// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"2a6c22e2","149":"56b1284b","166":"803d4b87","223":"6afd8534","249":"504f5ae2","304":"b2d0e7fd","360":"09cceacf","453":"a497a843","624":"3b45366f","885":"6e2b4e14"}[chunkId] + ".chunk.js";
};